import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Button } from '@material-ui/core';
import './Add-New-Popup-Model.scss';
import { formDataValidate } from '../../utils/formUtils';

function getModalStyle() {
  const top = 60;
  const left = 78;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  addNewPopup: {
    position: 'absolute',
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: '10px',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const AddNewPopUPModel = (props) => {
  const {
    addNewPopUp,
    onClickAdd,
    onClickCancel,
    renderModel,
    addNewField,
    addNewFormData,
    setAddNewFormData,
    formData,
  } = props;
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [isValidBtn, setIsValidBtn] = useState();

  useEffect(() => {
    if (formData) {
      const isValid = formDataValidate(formData, false);
      setIsValidBtn(!isValid);
    }
  }, [formData]);

  const handlePopupClose = () => {
    onClickCancel();
  };

  const onAddClick = () => {
    addNewField && addNewFormData && setAddNewFormData
      ? onClickAdd(addNewField, addNewFormData, setAddNewFormData)
      : onClickAdd();
  };

  const body = (
    <div style={modalStyle} className={classes.addNewPopup}>
      <div className='addNew-popup'>
        <div className='addNew-popup-title pt-4 pb-2'>Add {addNewPopUp.title}</div>
        <div className='px-2'>
          {addNewFormData && setAddNewFormData
            ? renderModel(addNewFormData, setAddNewFormData)
            : renderModel()}
        </div>
        <div className='col-md-12 d-flex justify-content-around mt-4'>
          <p>
            You can manage this {addNewPopUp.title} from the {addNewPopUp.title} Library
          </p>
        </div>
        <div className='col-md-10 offset-1 d-flex justify-content-center px-2 mt-1'>
          <Button
            className='mx-2 mt-2'
            variant='outlined'
            size='large'
            color='secondary'
            onClick={(e) => handlePopupClose()}
          >
            Cancel
          </Button>
          <Button
            className='mx-2 px-4 mt-2'
            variant='contained'
            size='large'
            color='primary'
            onClick={(e) => onAddClick()}
            disabled={isValidBtn}
          >
            Add
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className='no-border'>
      <Modal open={addNewPopUp.status} onClose={handlePopupClose}>
        {body}
      </Modal>
    </div>
  );
};

export default AddNewPopUPModel;
